import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import FEATURE_FLAG_NAMES from './featureFlagNames';

export const API_DISABLED_STATUS = '503';
export const API_DISABLED_CODE = 'API_DISABLED';

// Shaped like an apiRequest rejection so existing error handlers treat it as one.
export class ApiDisabledError extends Error {
  constructor(apiFlag) {
    super(`API disabled by feature flag: ${apiFlag}`);
    this.name = 'ApiDisabledError';
    this.status = API_DISABLED_STATUS;
    this.code = API_DISABLED_CODE;
    this.errors = [
      {
        status: API_DISABLED_STATUS,
        code: API_DISABLED_CODE,
        title: 'API disabled',
        detail: this.message,
      },
    ];
  }
}

/**
 * Throws an ApiDisabledError when `apiFlag` (a featureFlagNames key) is
 * explicitly false. A missing flag counts as enabled, so the switch only ever
 * turns calls off. Does nothing when no flag is given, so callers opt in.
 * @param {Function} getState redux getState
 * @param {string} [apiFlag] key from featureFlagNames
 */
export const assertApiEnabled = (getState, apiFlag) => {
  if (!apiFlag) return;
  if (toggleValues(getState())[FEATURE_FLAG_NAMES[apiFlag]] === false) {
    throw new ApiDisabledError(apiFlag);
  }
};
